import React, { useState } from "react";
import GlitchText from "./GlitchText";

export default function SideMenu() {
  const menuItems = [
  "X9b3Y#eP!oN2dT7@",
  "qL1hV@tH$eU5sR0%",
  "iM8r^U9sE*R6fA3!"
];



  const [selected, setSelected] = useState(null);

  return (
    <div className="side-menu">
      {menuItems.map((item, idx) => (
        <GlitchText
          key={idx}
          text={item}
          className={selected === idx ? "selected" : ""}
          onClick={() => setSelected(idx)}
        />
      ))}
    </div>
  );
}
